angular.module('TurneroApp').component('coTramitesModificar', {
    bindings: {
        ctrlPadre: '=',
    },
    controller: [
        '$mdDialog',
        'tramitesService',
        '$location',
        '$anchorScroll',
        'utilsService',
        'TurneroAppConstant',
        function ($mdDialog, tramitesService, $location, $anchorScroll, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.tramiteEditar = {};

            ctrl.errores = {
                nombre: false,
            };


            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    utilsService.swalTitle('Cargando Datos', 'info');

                    ctrl.errores = {
                        nombre: false,
                    };

                    if (item && item.IdTramite) {
                        ctrl.tramiteEditar = item;
                        swal.close();
                    }else { utilsService.errores(error) };
                }
            }

            ctrl.guardarTramiteModificado = function () {
                ctrl.errores.nombre = !ctrl.tramiteEditar.NTramite;

                if (ctrl.errores.nombre) {
                    $location.hash('formTramite');
                    $anchorScroll();
                    return;
                }
                //Actualizar tramite
                tramitesService.update({ 'id': ctrl.tramiteEditar.IdTramite }, ctrl.tramiteEditar).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Modificar Trámite", "El trámite se modificó correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };

            ctrl.cerrarModal = function () {
                $mdDialog.destroy();
            }

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./tramitesModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/tramites/tramitesModificarComponent.js